/**
 * 新闻类型
 */
export const NewsType = Object.freeze({
  最新: 'allNews',
  新闻: 'news',
  公告: 'notices',
  活动: 'activity',
});

/**
 * 新闻请求类型
 */
export const NewsFetchType = Object.freeze({
  [NewsType.最新]: '',
  [NewsType.新闻]: 0,
  [NewsType.公告]: 1,
  [NewsType.活动]: 2,
});

/**
 * 新闻模块显示类型
 */
export const DisplayType = Object.freeze({
  列表: 'list',
  更多: 'more',
  详情: 'detail',
});
